import { Stack, Text, Tooltip } from '@mantine/core';
import { formatHumanName } from '@medplum/core';
import { useTimelineContext } from '@/hooks/useTimelineContext';

export function TimelineItemProviders() {
  const { careTeamContext } = useTimelineContext();

  const { careTeamProviders: providers } = careTeamContext ?? {};
  const providersList = providers ?? [];

  return (
    <>
      {providersList.slice(0, Math.min(2, providersList.length)).map((provider, index) => {
        const fullName = formatHumanName(provider?.name?.[0]) || 'Unknown Provider';
        // Truncate long names to prevent overflow - shorter limit if multiple providers
        const maxLength = providersList.length > 1 ? 15 : 25;
        const displayName = fullName.length > maxLength ? `${fullName.substring(0, maxLength - 3)}...` : fullName;
        return (
          <Text key={provider.id} component="span" title={fullName}>
            {index > 0 && ', '}
            {displayName}
          </Text>
        );
      })}
      {providersList.length > 2 && (
        <Tooltip
          withArrow
          position="top"
          label={
            <Stack gap={4}>
              {providersList.slice(2).map((provider) => (
                <Text key={provider.id} size="sm">
                  {formatHumanName(provider?.name?.[0]) || 'Unknown Provider'}
                </Text>
              ))}
            </Stack>
          }
        >
          <Text component="span" style={{ cursor: 'help' }}>
            , +{providersList.length - 2} more
          </Text>
        </Tooltip>
      )}
    </>
  );
}
